import React from 'react';
import PropTypes from 'prop-types';
import { createUseStyles } from 'react-jss';
import { createSurveyStyles } from '@sm/webassets';
import { sanitizeString } from '@sm/utils';

const useThemeStyles = createUseStyles({
  surveyTitleContainer: {
    margin: [0, 40],
    paddingTop: 40,
  },
});

const useStyles = createSurveyStyles(theme => {
  return {
    surveyTitle: {
      ...theme?.surveyTitle,
      color: theme?.titleColor || theme?.surveyTitle?.color,
      padding: [40, 16, 8],
    },
  };
});

const SurveyTitle = ({ title }) => {
  const { surveyTitle } = useStyles();
  const { surveyTitleContainer } = useThemeStyles();
  return (
    <div
      className={`${surveyTitleContainer} ${surveyTitle}`}
      data-testid="SurveyTitle__Container"
      dangerouslySetInnerHTML={{ __html: sanitizeString(title) }}
    />
  );
};

SurveyTitle.propTypes = {
  title: PropTypes.string,
};

SurveyTitle.defaultProps = {
  title: '',
};

export default SurveyTitle;
